import { Children } from 'react';

export const Each = ({ of, render }) => {
  return Children.toArray(of?.map((item, index) => render(item, index)));
};
